import {FilterableSelect as CarbonFilterableSelect} from 'carbon-react/lib/components/select';
export {Option} from 'carbon-react/lib/components/select';

import {withFormik} from './carbon/formik';

/** Add new components here **/
export const FilterableSelect = withFormik('FilterableSelect', CarbonFilterableSelect, '');
